import React, { useContext } from "react"
import Slider from "react-slick"
import { ThemeContext, SectionTestimonials } from "Components"
import { CenterSection, SliderContent } from "Styles"
import { theme } from "Theme"
import styled from "styled-components"

const TestimonialsGrid = styled.div`
  color: inherit;
  width: 100%;
  position: relative;
  z-index: 3;
  padding: 0rem 0rem 2rem;
  margin: 2rem auto 0;
  max-width: ${theme.layout.base};

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  grid-gap: 16px;
`

const SliderSettings = {
  // className: 'xxx',
  // dotsClass: 'aaa',
  autoplay: true,
  useTransform: true,

  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  pauseOnHover: true,
  initialSlide: 1,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
        dots: true,
      },
    },
  ],
}

const SectionTestimonialz = ({ title, subtitle, testimonials, children }) => {
  const { mode } = useContext(ThemeContext)
  return (
    <CenterSection.Content>
      {title && <CenterSection.Title mode={mode}>{`${title}`}</CenterSection.Title>}
      {subtitle && <CenterSection.Subtitle>{`${subtitle}`}</CenterSection.Subtitle>}
      <SliderContent>
        {testimonials.edges.length <= 3 && (
          <TestimonialsGrid className={"no-padding"}>
            {testimonials.edges.map((testimonial, i) => {
              let cardTestimonialCategoryClass
              return (
                <SectionTestimonials
                  key={i}
                  data={testimonial}
                  className={`${cardTestimonialCategoryClass}`}
                  track={"Testimonial"}
                />
              )
            })}
          </TestimonialsGrid>
        )}
        {testimonials.edges.length > 3 && (
          <Slider {...SliderSettings}>
            {testimonials.edges.map((testimonial, i) => {
              return <SectionTestimonials key={i} data={testimonial} className={`${""}`} track={"Testimonial"} />
            })}
          </Slider>
        )}
      </SliderContent>
      {children}
    </CenterSection.Content>
  )
}

export default SectionTestimonialz
